enum ActionTypes {
  MAIN_INTERVIEWS_SET_PAGE = 'MENTOR_MAIN_INTERVIEWS_SET_PAGE',
  MAIN_INTERVIEWS_SET_ORDER = 'MENTOR_MAIN_INTERVIEWS_SET_ORDER',
  MENTEE_INTERVIEWS_SET_PAGE = 'MENTOR_MENTEE_INTERVIEWS_SET_PAGE',
  MENTEE_INTERVIEWS_SET_ORDER = 'MENTOR_MENTEE_INTERVIEWS_SET_ORDER',
}

export default ActionTypes;
